import api from '@motionelements/core/src/api/base-api-v2';

const baseUrl = '/v2/artist/releases';

// use for element-list
export const listReleaseFiles = async (params) => {
  params = params || {};
  if (!params.sort) {
    params.sort = '-created_at';
  }

  const config = {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
  };
  return api.get(baseUrl, config);
};

export const getReleaseFileInfo = async (id) => {
  if (!id) return false;

  const config = {
    params: {
      ...api.getLocaleParams(),
    },
  };
  return api.get(`${baseUrl}/${id}`, config)
    .then((response) => response.data.data);
};

export const downloadReleaseFile = async (id) => {
  if (!id) return false;

  const config = {
    params: {
      // ...api.getLocaleParams(),
    },
  };
  return api.request('post', `${baseUrl}/${id}/download`, config);
  // .then((response) => response.data.data);
};

export const deleteReleaseFile = async (id) => {
  const url = `${baseUrl}/${id}`;
  return api.request('delete', url);
};

// export const saveRelease = data => api.request('post', baseUrl, { data })
//   .then(({ data: { data } }) => data);

// export const saveRelease = data => api.request('post', baseUrl, { data });
// .then((response)a);

export const saveReleaseFile = async (data) => api.request('post', baseUrl, { data });

